<template>
  <div>
    <v-data-table
      :headers="headers"
      :loading="loading"
      :search="search"
      :items="mysqlDatabases"
    >
      <!-- Users -->
      <template v-slot:item.userlist="{ item }">
        <privileged-users-cell
          :users="item.userlist"
          @action-completed="actionCompleted($event)"
        />
      </template>
      <!-- Actions -->
      <template v-slot:item.actions="{ item }">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <gg-btn v-on="on" v-bind="attrs">
              Manage <v-icon right>mdi-chevron-down</v-icon>
            </gg-btn>
          </template>
          <v-list>
            <v-list-item @click="openAddUserModal(item)">
              <v-list-item-title>Add User</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openRenameModal(item)">
              <v-list-item-title>Rename</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openDeleteModal(item)">
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <delete-database-modal
      v-if="selectedDatabase"
      :database="selectedDatabase"
      :opened="deleteModalOpened"
      @close="closeDeleteModal"
      @action-completed="actionCompleted($event)"
    />
    <rename-database-modal
      v-if="selectedDatabase"
      :database="selectedDatabase"
      :opened="renameModalOpened"
      @close="closeRenameModal"
      @action-completed="actionCompleted($event)"
    />
    <add-user-modal
      v-if="selectedDatabase"
      :database="selectedDatabase.db"
      mode="database"
      :opened="addUserModalOpened"
      @close="closeAddUserModal"
      @action-completed="actionCompleted($event)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PrivilegedUsersCell from './PrivilegedUsersCell'
import DeleteDatabaseModal from './DeleteDatabaseModal'
import RenameDatabaseModal from './RenameDatabaseModal'
import AddUserModal from './AddUserModal'

export default {
  name: 'DatabasesTable',
  components: {
    PrivilegedUsersCell,
    DeleteDatabaseModal,
    RenameDatabaseModal,
    AddUserModal,
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    search: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'Database',
          value: 'db',
        },
        {
          text: 'Privileged users',
          value: 'userlist',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          align: 'center',
        }
      ],
      // search: '',
      deleteModalOpened: false,
      renameModalOpened: false,
      addUserModalOpened: false,
      selectedDatabase: null,
    }
  },
  computed: {
    ...mapGetters({
      mysqlDatabases: 'mysql/mysqlDatabases',
      pagination: 'pagination'
    }),
  },
  methods: {
    actionCompleted (e) {
      switch (e) {
        case 'database-deleted':
          this.closeDeleteModal()
          break
        default:
          break
      }
      this.$emit('table-action-completed', e)
    },
    openDeleteModal (database) {
      this.selectedDatabase = database
      this.deleteModalOpened = true
    },
    closeDeleteModal () {
      this.selectedDatabase = null
      this.deleteModalOpened = false
    },
    openRenameModal (database) {
      this.selectedDatabase = database
      this.renameModalOpened = true
    },
    openAddUserModal (database) {
      this.selectedDatabase = database
      this.addUserModalOpened = true
    },
    closeRenameModal () {
      this.selectedDatabase = null
      this.renameModalOpened = false
    },
    closeAddUserModal () {
      this.selectedDatabase = null
      this.addUserModalOpened = false
    },
  },
}
</script>
